import { useNavigate } from "react-router-dom";
import { BOT_1, BOT_2, BOT_3, TOKEN } from "./Constants/constants";
import { useContext } from "react";
import { AppContext } from "./Context/Context";

export default function Home({ setBotUrl }) {
    const navigate = useNavigate();
    const { setChatId, setBotHistory } = useContext(AppContext)

    const openChat = () => {
        if (TOKEN) {
            localStorage.setItem("BOT", 'wss://auditaibot.soof.uz/ws/audit')
            setBotHistory('xas')
            localStorage.setItem('chatbot', 'xas')
            setChatId(0)
            navigate('/chat')
            // window.location.reload()
        } else {
            navigate('/login')
        }
    };

    const handleOpenChat = () => {
        if (TOKEN) {
            localStorage.setItem('BOT', "wss://auditaibot.soof.uz/ws/mhxs")
            setBotHistory('mhxs')
            localStorage.setItem('chatbot', 'mhxs')
            setChatId(0)
            navigate('/chat')
            // window.location.reload()
        } else {
            navigate('/login')
        }
    };

    const openChat2 = () => {
        if (TOKEN) {
            localStorage.setItem("BOT", "wss://auditaibot.soof.uz/ws/soliq")
            setBotHistory('soliq')
            localStorage.setItem('chatbot', 'soliq')
            setChatId(0)
            navigate('/chat')
            // window.location.reload()
        } else {
            navigate('/login')
        }
    };

    const loginBtn = () => {
        if (!TOKEN) {
            navigate('/login')
        } else {
            localStorage.clear()
            window.location.reload()
        }
    }

    return (
        <div className="home-body">
            <div>
                <div className="background"></div>

                <header>
                    <div className="header-content">
                        <div className="logo">
                            <div className="logo-icon">
                                <i className="fas fa-chart-line"></i>
                            </div>
                            <div className="logo-text">
                                <h1>IFRS Assistant</h1>
                                <p>Financial Standards Support</p>
                            </div>
                        </div>
                        <nav className="nav-menu">
                            <button
                                className="btn btn-primary"
                                onClick={loginBtn}
                            >
                                {TOKEN ? "Log out" : "Login"}
                            </button>
                        </nav>
                    </div>
                </header>

                <main>
                    <section className="hero-section" id="home">
                        <h1 className="hero-title">Tax Assistant</h1>
                        <p className="hero-subtitle">
                            Your reliable resource for staying up to date with the latest tax changes and ensuring the correct application of tax regulations in practice. 
                        </p>
                        <div className="cta-buttons">
                            <a onClick={openChat2} className="btn btn-primary">
                                <i className="fas fa-play"></i> Getting Started
                            </a>
                        </div>
                    </section>

                    {/* <section className="features-section" id="features">
                        <div className="features-grid">
                           
                            <div style={{ cursor: 'pointer' }} onClick={openChat}>
                                <div
                                    id="bot_1"
                                    className="feature-card"
                                    onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                        "translateY(-15px) scale(1.02)")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.transform = "translateY(0) scale(1)")
                                    }
                                >
                                    <h3>ISA Assistant</h3>
                                    <p>

                                       International Standards on Auditing (ISA) are a cornerstone of the modern financial oversight system. We have developed this resource to make your journey through the complex world of ISA clearer, more transparent, and more effective.
                                    </p>
                                </div>
                            </div>


                            <div style={{ cursor: 'pointer' }} onClick={openChat2}>
                                <div
                                    className="feature-card"
                                    onMouseEnter={(e) =>
                                    (e.currentTarget.style.transform =
                                        "translateY(-15px) scale(1.02)")
                                    }
                                    onMouseLeave={(e) =>
                                        (e.currentTarget.style.transform = "translateY(0) scale(1)")
                                    }
                                >
                                    <h3>Tax Assistant</h3>
                                    <p>
                                       Your reliable resource for staying up to date with the latest tax changes and ensuring the correct application of tax regulations in practice.
                                    </p>
                                </div>
                            </div>
                            
                        </div>
                    </section> */}
                </main>

                <footer>
                    <p>
                        &copy; 2024 Grant Thornton Uzbekistan. МСФО Ассистент - Professional
                        Financial Standards Support
                    </p>
                </footer>
            </div>
        </div>
    );
}
